import { queryMediaList, addMedia, updateMedia } from '../requests';

const initPagination = {
  pageSize: 10,
  currentPage: 1,
  total: 0,
};

const Model = {
  namespace: 'mediaManagement',
  state: {
    tabledData: [],
    pagination: initPagination,
  },
  effects: {
    *queryMediaList({ payload }, { call, put }) {
      const res = yield call(queryMediaList, payload);
      if (res && res.code === 0) {
        yield put({ type: 'saveMediaList', payload: res.data });
      }
    },
    *addMedia({ payload }, { call }) {
      return yield call(addMedia, payload);
    },
    *updateMedia({ payload }, { call }) {
      return yield call(updateMedia, payload);
    },
  },
  reducers: {
    saveMediaList(state, { payload }) {
      const { pageNum, pageSize, total, dataInfos } = payload;
      const pagination = {
        currentPage: pageNum,
        pageSize,
        total,
      };
      return { ...state, tabledData: dataInfos, pagination };
    },
  },
};
export default Model;
